import React from 'react';

import { View } from '@react-pdf/renderer';
import { StyleSheet } from '@react-pdf/renderer';
import { SubChapterHeading } from 'PDF/components/SubChapterHeading';
import { getColorObjectStyleByRecord } from 'PDF/helpers/documentStyle';
import { MissionAndVisionRow } from 'PDF/pages/AboutTheCompany/MissionAndVisionTable/MissionAndVisionRow';
import { IMissionData } from 'PDF/pages/AboutTheCompany/types';
import { globalStyles } from 'PDF/styles';

interface IProps {
  tableData: IMissionData[];
  heading: string;
}

const colorIndexes = {
  green: 2,
  blue: 2,
  red: 2,
  blueGreen: 2,
  blueRed: 2,
  blueYellow: 35,
};

export const MissionAndVisionTable: React.FC<IProps> = ({ tableData, heading }) => {
  const wrapColor = getColorObjectStyleByRecord(colorIndexes, 'backgroundColor');
  const firstRow = tableData[0];

  if (!tableData || !tableData.length) {
    return null;
  }

  return (
    <View>
      <View minPresenceAhead={300} />
      <View style={[globalStyles.marginBottom]}>
        <View wrap={false}>
          <SubChapterHeading heading={heading} id="missionAndStrategy" />
          <View style={[wrapColor, styles.firstContainer]}>
            <MissionAndVisionRow
              item={firstRow}
              rowStyles={
                tableData.length === 1 ? styles.firstContainerWithBottomPadding : styles.firstContainerWithOthers
              }
            />
          </View>
        </View>
        {tableData.slice(1).map((item, index, currentArray) => (
          <View key={index} style={[wrapColor, styles.container]}>
            <MissionAndVisionRow
              key={index}
              item={item}
              rowStyles={index === 1 || currentArray.length === 1 ? styles.lastRowStyles : styles.secondRowStyles}
            />
          </View>
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  firstContainer: {
    padding: '24px 19px 0',
  },
  firstContainerWithBottomPadding: {
    paddingBottom: '24px',
  },
  firstContainerWithOthers: {
    paddingBottom: '8px',
  },
  container: {
    padding: '0 19px',
  },
  secondRowStyles: {
    paddingTop: '8px',
    paddingBottom: '8px',
  },
  lastRowStyles: {
    paddingTop: '8px',
    paddingBottom: '24px',
  },
});
